import {Box, Typography} from "@mui/material"
import React from "react"
import {getAntworttyp, getOptions} from "../../misc/widget-functions"
import {isObject} from "lodash"
import moment from "moment"
import {setPxSuffix} from "../../misc/utils"

export const widgetValuePrototype = [
    {
        key: "fontWeight",
        type: "SELECT",
        label: "Font weight",
        size: 3,
        options: [
            {
                value: "100",
                label: "100",
            },
            {
                value: "200",
                label: "200",
            },
            {
                value: "300",
                label: "300",
            },
            {
                value: "400",
                label: "400",
            },
            {
                value: "500",
                label: "500",
            },
            {
                value: "600",
                label: "600",
            },
            {
                value: "700",
                label: "700",
            },
            {
                value: "800",
                label: "800",
            },
            {
                value: "900",
                label: "900",
            },
        ],
    },
    {
        key: "color",
        type: "COLOR",
        label: "Textfarbe",
        size: 3,
    },
    {
        key: "suffix",
        type: "STRING",
        label: "Suffix",
        size: 3,
    },
    {
        key: "padding",
        type: "STRING",
        label: "Padding",
        size: 3,
    },
    {
        key: "displayProperty",
        type: "STRING",
        label: "Anzweige Property (falls Wert ein Objekt ist)",
        size: 3,
    },
    {
        key: "parts",
        type: "CONNECTOR",
        label: "Merkmale",
        size: 6,
        options: {
            treeName: "attributes",
            isSingleConnection: false,
            connectorProperties: [
                {
                    key: "prefix",
                    type: "STRING",
                    label: "Prefix",
                    size: {
                        xs: 12,
                        md: 6,
                    },
                },
                {
                    key: "suffix",
                    type: "STRING",
                    label: "Suffix",
                    size: {
                        xs: 12,
                        md: 6,
                    },
                },
            ],
        },
    },
    {
        key: "textAlignment",
        type: "SELECT",
        label: "Text Positionierung",
        size: 3,
        options: [
            {
                value: "LEFT",
                label: "Links",
            },
            {
                value: "RIGHT",
                label: "Rechts",
            },
            {
                value: "CENTER",
                label: "Mittig",
            },
        ],
    },
    {
        key: "fontWeight",
        type: "SELECT",
        label: "Font weight",
        size: 3,
        options: [
            {
                value: "100",
                label: "100",
            },
            {
                value: "200",
                label: "200",
            },
            {
                value: "300",
                label: "300",
            },
            {
                value: "400",
                label: "400",
            },
            {
                value: "500",
                label: "500",
            },
            {
                value: "600",
                label: "600",
            },
            {
                value: "700",
                label: "700",
            },
            {
                value: "800",
                label: "800",
            },
            {
                value: "900",
                label: "900",
            },
        ],
    },
    {
        "key": "fontSize",
        "type": "INTEGER",
        "label": "Font Size in px",
        "size": 3
    },
    {
        key: "showFractionDigits",
        type: "YESNO",
        label: "Nachkommastellen anzeigen",
        size: 3,
        defaultValue: true
    },
]

const setFractionDigits = (value, showFractionDigits = true) => ({
    minimumFractionDigits: showFractionDigits ? value : 0,
    maximumFractionDigits: showFractionDigits ? value : 0,
})

const formatValue = (value, antworttyp, options, widget) => {
    if (_.isBoolean(value)) return value ? "Ja" : "Nein"
    if (options?.length) {
        const option = options?.find((option) => _.isEqual(option.value, value))
        return option?.[widget?.subtext || "label"] ?? ""
    }
    if (antworttyp === "MONETARYAMOUNT") {
        const currencyFormated =
            typeof value === "number"
                ? value?.toLocaleString("de-DE", {
                    style: "currency",
                    currency: "EUR",
                    ...setFractionDigits(2, widget?.showFractionDigits)
                })
                : "-"
        return currencyFormated
    }
    if (antworttyp === "DATE")
        return moment(value, "YYYY-MM-DD").format("DD.MM.YYYY")
    if (antworttyp === "PERCENTAGE")
        return typeof value === "number"
            ? `${value?.toLocaleString("de-DE", setFractionDigits(2,  widget?.showFractionDigits))} %`
            : "-"
    if (antworttyp === "PROMILLE")
        return typeof value === "number"
            ? `${value?.toLocaleString("de-DE", setFractionDigits(4,  widget?.showFractionDigits))} ‰`
            : "-"
    if (isObject(value))
        return widget?.displayProperty
            ? value[widget.displayProperty]
            : value.label
    return value ?? ""
}

const ValueWidget = ({widget, value, getDataFromPointer, disabled}) => {
    if (widget.parts?.length) {
        const displayValue = widget.parts
            .map((part) => {
                const val = getDataFromPointer(part.origin?.pointer)
                const partOptions = part.origin?.connections?.origin?.children ?? []
                const formatted = formatValue(
                    val,
                    part.origin?.antworttyp,
                    partOptions,
                    widget,
                )
                return (part.prefix ?? "") + formatted + (part.suffix ?? "")
            })
            .join("")

        return (
            <Box p={widget.padding}>
                <Typography
                    fontSize={setPxSuffix(widget?.fontSize)}
                    disabled={disabled}
                    color={widget?.color}
                    fontWeight={widget.fontWeight ?? "400"}
                    textAlign={widget?.textAlignment}>
                    {displayValue}
                </Typography>
            </Box>
        )
    }

    const options = getOptions(widget)
    const antworttyp = getAntworttyp(widget)
    const displayValue = formatValue(value, antworttyp, options, widget)
    const option = options?.find((option) => _.isEqual(option.value, value))
    const fontColor = option?.color ?? ""
    const bgColor = option?.backgroundcolor ?? ""

    return (
        <Box
            p={widget.padding}
            sx={{color: fontColor, backgroundColor: bgColor}}>
            <Typography
                fontSize={setPxSuffix(widget?.fontSize)}
                color={widget?.color}
                fontWeight={widget.fontWeight ?? "400"}
                textAlign={widget?.textAlignment}>
                {displayValue}
            </Typography>
        </Box>
    )
}

export default ValueWidget
